// 3rd party Modules
import * as React from 'react';

// Providers
import { ServicesContext } from '~/providers/services-context';

// Utils
import { comp } from '~/utils/us-utils';

// Interfaces
type Identifier = 'Signup' | 'Login' | 'Profile' | 'Settings' | 'Subscriptions';
interface IProps {
  currentPanel: string;
  goTo: (props: {panelIdentifier: Identifier;}) => void;
  goBack?: () => void;
  model?: {showBack: boolean;};
}

// Styles
import styles from '../style/tabs.module.css';

class Tabs extends React.Component<IProps, any> {
  static contextType = ServicesContext;

  constructor(public props: IProps) {
    super(props);
  }

  private renderTabs(): JSX.Element | null {
    const { currentPanel, goTo, goBack, model } = this.props;

    const isLogin = currentPanel === 'Login';
    const isSignup = currentPanel === 'Signup';

    const isProfile = currentPanel === 'Profile';
    const isSettings = currentPanel === 'Settings';
    const isSubscriptions = currentPanel === 'Subscriptions';

    const isForgotPassword = currentPanel === 'ForgotPassword';
    const isForgotPasswordComplete = currentPanel === 'ForgotPasswordComplete';
    const isResetPassword = currentPanel === 'ResetPassword';

    switch (true) {
      case isLogin:
      case isSignup:
        return (
          <div className={styles.actions}>
						<span
              className={comp(styles.signup, isSignup ? styles.selected : '')}
              onClick={() => goTo({ panelIdentifier: 'Signup' })}>

							{this.context.labelActions.get('SIGN_UP')}
						</span>
						<span
              className={comp(styles.login, isLogin ? styles.selected : '')}
              onClick={() => goTo({ panelIdentifier: 'Login' })}>

							{this.context.labelActions.get('LOG_IN')}
						</span>
					</div>);


      case isProfile:
      case isSettings:
      case isSubscriptions:
        return (
          <div className={styles.actions}>
						<span
              data-testid="profile-tab"
              className={comp(styles.tab, isProfile ? styles.selected : '')}
              onClick={() => goTo({ panelIdentifier: 'Profile' })}>

							{this.context.labelActions.get('PROFILE')}
						</span>
						<span
              data-testid="settings-tab"
              className={comp(styles.tab, isSettings ? styles.selected : '')}
              onClick={() => goTo({ panelIdentifier: 'Settings' })}>

							{this.context.labelActions.get('SETTINGS')}
						</span>
						<span
              data-testid="subscriptions-tab"
              className={comp(
                styles.tab,
                isSubscriptions ? styles.selected : ''
              )}
              onClick={() => goTo({ panelIdentifier: 'Subscriptions' })}>

							{this.context.labelActions.get('SUBSCRIPTIONS')}
						</span>
					</div>);


      case isForgotPassword:
      case isForgotPasswordComplete:
      case isResetPassword:
        return (
          <div className={styles.actions}>
						<span
              className={comp(
                styles.password,
                styles.forgotWrapper,
                styles.selected
              )}>

							{model?.showBack ?
              <span className={styles.forgotBack} onClick={goBack}>
									<span className={styles.backArrow} />
								</span> :
              null}
							<span className={styles.forgot} data-testid="reset-password">
								{this.context.labelActions.get('RESET_PASSWORD')}
							</span>
						</span>
					</div>);


      default:
        return null;
    }
  }

  public render(): JSX.Element {
    return <div className={styles.tabs}>{this.renderTabs()}</div>;
  }
}

export default Tabs;